import { Link } from '@remix-run/react'
import { Button } from '../ui/button.tsx'
import { Icon } from '../ui/icon.tsx'

export function NewRecipeButton({ username }: { username: string }) {
	return (
		<Button asChild variant="default" size="sm" className="fit px-2 sm:px-3">
			<Link prefetch="intent" to={`/${username}/recipes/new`}>
				<Icon className="text-body-md" name="plus">
					<span className="hidden md:inline">New Recipe</span>
				</Icon>
			</Link>
		</Button>
	)
}

export function EditProfileButton({ username }: { username: string }) {
	return (
		<Button asChild variant="secondary" size="xs">
			<Link prefetch="intent" to={`/${username}/settings/profile`}>
				Edit Profile
			</Link>
		</Button>
	)
}

export function NewLinkButton() {
	return (
		<Button asChild variant="default" size="sm" className="fit">
			<Link to="new" prefetch="intent">
				<Icon className="text-body-md" name="plus">
					New Link
				</Icon>
			</Link>
		</Button>
	)
}
